import { Component, OnInit } from '@angular/core';
import { ModalService } from '../../shared/services/modal.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthServiceService } from '../../core/http/auth-service.service';
import { SettingsService } from '../../core/http/settings.service';
import { SampleService } from '../../core/http/sample.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import * as _moment from 'moment';
const moment = _moment;

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
})
export class ProfileComponent implements OnInit {
  profile;
  isLoading;
  Errors;
  signatureImage;
  mode = 'all';
  users = null;
  data = null;
  employees: any = [];
  types: any = [];
  Success = null;
  filterddata: any = [];
  private _searchText: string;
  points = [];
  type = 'form';
  new = 'form1';
  role = localStorage.getItem('role');
  date_of_birth;
  date;
  emplyees;
  startdate = '';
  enddate = '';
  userRole = localStorage.getItem('role');
  sex = '';
  name = '';
  phone = '';
  ultrasound;
  appVersionNumber: any;
  dashboardData: any = {};

  constructor(
    public set: SettingsService,
    public setting: SettingsService,
    public auth: AuthServiceService,
    private sample: SampleService,
    private _snackBar: MatSnackBar
  ) {}

  getPatients() {
    this.setting.getPatient().subscribe(
      (resSuccess) => {
        this.emplyees = resSuccess;
        this.isLoading = false;
        console.log(resSuccess);
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
        console.log(resErr);
      }
    );
  }

  DateChange(event: any) {
    const dob_entry = moment(event.target.value).format('YYYY/MM/DD');
    const currentDate = moment(new Date()).format('YYYY/MM/DD');

    let split_dob = dob_entry.split('/');
    let splitCurrentDate = currentDate.split('/');
    let currentYear = +splitCurrentDate[0];
    let year = +split_dob[0];
    let age = currentYear - year;

    console.log('your age is' + age + 'which is' + currentYear + '+' + year);
    // this.stateForm.patchValue({
    //   age: age,
    // });
    console.log(age);
    console.log(event.target.value);

    this.date = '';
  }

  stateForm = new FormGroup({
    Employee_id: new FormControl('', Validators.required),
    First_Name: new FormControl('', Validators.required),
    Middle_Name: new FormControl('', Validators.required),
    Last_Name: new FormControl('', Validators.required),
    U_Name: new FormControl('', Validators.required),
    Position_Id: new FormControl('', Validators.required),
    Address: new FormControl('', Validators.required),
    Phone_No: new FormControl('', Validators.required),
    Email_id: new FormControl('', Validators.required),
    Flag: new FormControl('', Validators.required),
    designation: new FormControl('', Validators.required),
    signature: new FormControl('', Validators.required),
    qualification: new FormControl(''),
    IsDeleted: new FormControl(null),
    password: new FormControl('', Validators.required),
    CanAuthDiscount: new FormControl(''),
  });

  ngOnInit(): void {
    this.setting.appVersion().subscribe(
      (resSuccess) => {
        this.appVersionNumber = resSuccess;
        this.isLoading = false;
        console.log(this.appVersionNumber?.version, 'Versionnnnnnnnnnnnn');
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
        console.log(resErr);
      }
    );

    if (
      this.role == 'self-service user' ||
      this.role == 'self-service consultant'
    ) {
      this.set.getProfileonline().subscribe(
        (resSuccess) => {
          this.profile = resSuccess;
          this.signatureImage = this.profile.signature;
          this.isLoading = false;
          this.stateForm.patchValue({
            Employee_id: this.profile.userid,
            First_Name: this.profile.first_name,
            Last_Name: this.profile.last_name,
            U_Name: this.profile.username,
            Address: this.profile.branch_address,
            Email_id: this.profile.email,
            designation: this.profile.designation,
          });
          console.log(this.stateForm.value);
          console.log(resSuccess);
        },
        (resErr) => {
          this.isLoading = false;
          this.Errors = resErr;
        }
      );
    } else {
      this.set.getProfile().subscribe(
        (resSuccess) => {
          this.profile = resSuccess;
          this.signatureImage = this.profile.signature;
          this.isLoading = false;
          this.stateForm.patchValue({
            Employee_id: this.profile.userid,
            First_Name: this.profile.first_name,
            Last_Name: this.profile.last_name,
            U_Name: this.profile.username,
            Address: this.profile.branch_address,
            Email_id: this.profile.email,
            designation: this.profile.designation,
          });
          console.log(this.stateForm.value);
          console.log(resSuccess);
        },
        (resErr) => {
          this.isLoading = false;
          this.Errors = resErr;
        }
      );
    }

    this.sample.getDashboardData().subscribe(
      (resSuccess: any) => {
        resSuccess.forEach((item) => {
          if (item.Value !== "0") {
            this.dashboardData[item.Key.replace(' ','').toUpperCase()] = item.Value;
          }
        });
        console.log('Dashboard Data:', this.dashboardData);
      },
      (resErr) => {
        console.log('Error fetching dashboard data:', resErr);
      }
    );
  }
  numberWithCommas(x) {
      return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
  }
  getResult() {
    this.isLoading = true;
    this.sample
      .searchResults(
        this.startdate,
        this.enddate,
        this.name,
        this.phone,
        this.sex
      )
      .subscribe(
        (resSuccess: any) => {
          let data = [];
          data = resSuccess.data.filter(
            (x) =>
              x.department_name == 'RADIOLOGY' ||
              x.department_name == 'ULTRASOUND'
          );
          for (let i = 0; i < data.length; i++) {
            if (
              data[i].service_name == 'Obstetric' ||
              data[i].service_name == 'OBS'
            ) {
            } else {
              this.data.push(data[i]);
            }
          }

          this.isLoading = false;
          this.ultrasound = resSuccess;
          console.log(resSuccess);
          console.log(data);
          console.log(this.data);
          this.isLoading = false;
        },
        (resErr) => {
          this.Errors = resErr;
          this.isLoading = false;
        }
      );
  }

  refetch() {
    this.set.getProfile().subscribe(
      (resSuccess) => {
        this.profile = resSuccess;
        this.signatureImage = this.profile.signature;
        this.isLoading = false;
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
      }
    );
  }

  onSubmit() {
    this.isLoading = true;
    this.Errors = null;
    this.Success = null;
    const {
      Employee_id,
      First_Name,
      Middle_Name,
      Last_Name,
      U_Name,
      Position_Id,
      Address,
      Phone_No,
      Email_id,
      Flag,
      designation,
      signature,
      password,
      IsDeleted,
      qualification,
      CanAuthDiscount,
    } = this.stateForm.value;

    if (
      this.role == 'self-service user' ||
      this.role == 'self-service consultant'
    ) {
      this.set
        .postUseronline(
          Employee_id,
          First_Name,
          Middle_Name,
          Last_Name,
          U_Name,
          Position_Id,
          Address,
          Phone_No,
          Email_id,
          Flag,
          designation,
          signature,
          password,
          IsDeleted,
          qualification,
          CanAuthDiscount
        )
        .subscribe(
          (resSuccess) => {
            this.data = resSuccess;
            this.isLoading = false;

            if (this.data.success) {
              this._snackBar.open('Saved Successfully', '', {
                duration: 2000,
                verticalPosition: 'top',
              });
              this.refetch();
              this.data = 'all';
            } else {
              this._snackBar.open('Error something went wrong', '', {
                duration: 2000,
                verticalPosition: 'top',
              });
              console.log(resSuccess);
            }
          },
          (resErr) => {
            this.isLoading = false;
            this._snackBar.open(resErr, '', {
              duration: 2000,
              verticalPosition: 'top',
            });
            console.log(resErr);
          }
        );
    } else {
      this.set
        .postUser(
          Employee_id,
          First_Name,
          Middle_Name,
          Last_Name,
          U_Name,
          Position_Id,
          Address,
          Phone_No,
          Email_id,
          Flag,
          designation,
          signature,
          password,
          IsDeleted,
          qualification,
          CanAuthDiscount
        )
        .subscribe(
          (resSuccess) => {
            this.data = resSuccess;
            this.isLoading = false;

            if (this.data.success) {
              this._snackBar.open('Saved Successfully', '', {
                duration: 2000,
                verticalPosition: 'top',
              });
              this.refetch();
              this.data = 'all';
            } else {
              this._snackBar.open('Error something went wrong', '', {
                duration: 2000,
                verticalPosition: 'top',
              });
              console.log(resSuccess);
            }
          },
          (resErr) => {
            this.isLoading = false;
            this._snackBar.open(resErr, '', {
              duration: 2000,
              verticalPosition: 'top',
            });
            console.log(resErr);
          }
        );
    }
  }

  showImage1(data) {
    this.signatureImage = data;
    this.new = 'form1';
    this.stateForm.patchValue({
      signature: data,
    });

    this.onSubmit();
    console.log(this.stateForm.value);
  }

  addSign() {
    this.mode = 'sign1';
  }
  back() {
    this.mode = 'all';
  }
}
